import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	scrollContainer: {
		overflowX: 'auto',
		// Scroll-linked overflow shadows using the background-attachment local/scroll trick.
		// The first two gradients (surface colour covers) are `local` — they scroll with the
		// content and hide the shadow when the edge is not reached. The last two (actual shadows)
		// are `scroll` — fixed to the container viewport so they always sit at the edges.
		backgroundImage: `linear-gradient(to right, ${token('elevation.surface')}, ${token('elevation.surface')}), linear-gradient(to left, ${token('elevation.surface')}, ${token('elevation.surface')}), linear-gradient(to right, ${token('elevation.shadow.overflow.spread')}, transparent), linear-gradient(to left, ${token('elevation.shadow.overflow.spread')}, transparent)`,
		backgroundPosition: 'left center, right center, left center, right center',
		backgroundRepeat: 'no-repeat',
		backgroundSize: `${token('space.100')} 100%, ${token('space.100')} 100%, ${token('space.100')} 100%, ${token('space.100')} 100%`,
		backgroundAttachment: 'local, local, scroll, scroll',
	},
});

interface ScrollContainerProps {
	children: React.ReactNode;
}

/**
 * A horizontally scrollable container that renders a gradient shadow on the left and/or right
 * edge when there is overflow content in that direction, providing a visual cue to the user.
 */
export const ScrollContainer = ({ children }: ScrollContainerProps): React.JSX.Element => (
	<Box xcss={styles.scrollContainer}>{children}</Box>
);
